import React from "react";
import EventDetailZoomView from "./view";
import { Event } from "../../../../data/interfaces";

interface Props {
  event: Event;
  roomInitializedCallback: (res: boolean) => void;
}

const EventDetailZoomContainer = (props: Props) => {
  return <EventDetailZoomView {...props} />;
};

export default EventDetailZoomContainer;
